import * as React from 'react';
import { AnimatedContainer } from '../../components/AnimatedContainer';
import { QuestionsAndAnswers, QuestionsAndAnswersItem } from '../../components/LandingPageV2/QuestionsAndAnswers';

interface IQuestionAnswerItem {
  type: 'service' | 'consultant' | 'support' | 'partial' | 'existing';
  title: string;
  description: string;
}

const DEFAULT_CONTENT: IQuestionAnswerItem[] = [
  {
    type: 'service',
    title: 'Чем вы можете помочь и сколько это стоит?',
    description:
      'Мы помогаем подобрать квартиру, забронировать её и подготовиться к сделке — для пользователей Циана это бесплатно. Некоторые услуги застройщика могут быть платными — например, бронирование. Мы заранее об этом предупредим.',
  },
  {
    type: 'consultant',
    title: 'Кто будет делать подборку квартир?',
    description:
      'С вами будет работать один из наших консультантов — это настоящие гуру поиска жилья, которые отсмотрят за вас тысячи объявлений и найдут тот самый вариант.',
  },
  {
    type: 'support',
    title: 'А кто будет сопровождать до сделки? И что туда входит?',
    description:
      'Наш специалист по новостройкам — консультант передаст ему всю информацию по квартире, которая вам понравилась. Специалист посоветует подходящую ипотечную программу, поможет с бронированием и подскажет, какие документы понадобятся.',
  },
  {
    type: 'partial',
    title: 'Можно заказать только подборку квартир, без сопровождения до сделки?',
    description:
      'Да, без проблем. Если передумаете и захотите, чтобы мы помогли вам с бронированием и документами, — просто скажите об этом своему консультанту.',
  },
  {
    type: 'existing',
    title: 'А наоборот — если я уже знаю, какую квартиру хочу, и мне нужно только сопровождение?',
    description:
      'Можно, если вы нашли объявление на Циане и на нём есть кнопка «Заявка на бронирование»: нажмите на неё, заполните короткую заявку и ждите звонка от нашего специалиста.',
  },
];

export const QuestionsAndAnswersContainer = () => {
  return (
    <QuestionsAndAnswers>
      {DEFAULT_CONTENT.map(item => (
        <AnimatedContainer key={item.title}>
          <QuestionsAndAnswersItem key={item.title} type={item.type} question={item.title} answer={item.description} />
        </AnimatedContainer>
      ))}
    </QuestionsAndAnswers>
  );
};
